/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { IncidentsPersonnePhysiqueDto } from '../models/incidents-personne-physique-dto';
import { LoadResult } from '../models/load-result';
import { PersonnePhysiqueDto } from '../models/personne-physique-dto';
import { PersonnePhysiqueSetEmailRequestDto } from '../models/personne-physique-set-email-request-dto';
import { QuotaVisiteurDto } from '../models/quota-visiteur-dto';
import { VisitePersonnePhysiqueDto } from '../models/visite-personne-physique-dto';


/**
 * Fonctions de gestion des personnes physiques
 */
@Injectable({
  providedIn: 'root',
})
export class PersonnesPhysiquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation personnePhysiqueGetList
   */
  static readonly PersonnePhysiqueGetListPath = '/api/personnes-physiques/list';

  /**
   * Renvoie la liste des personnes physiques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PersonnePhysiqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonnePhysiqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes physiques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetList(params?: {
  }): Observable<Array<PersonnePhysiqueDto>> {

    return this.personnePhysiqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonnePhysiqueDto>>) => r.body as Array<PersonnePhysiqueDto>)
    );
  }

  /**
   * Path part for operation personnePhysiqueLoadList
   */
  static readonly PersonnePhysiqueLoadListPath = '/api/personnes-physiques/load-list';

  /**
   * Renvoie la liste des personnes physiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes physiques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueGet
   */
  static readonly PersonnePhysiqueGetPath = '/api/personnes-physiques/{id}';

  /**
   * Renvoie la personne physique spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGet$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    id: number;
  }): Observable<StrictHttpResponse<PersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la personne physique spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGet(params: {

    /**
     * Identifiant de la personne physique
     */
    id: number;
  }): Observable<PersonnePhysiqueDto> {

    return this.personnePhysiqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiqueDto>) => r.body as PersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueVisitesLoadList
   */
  static readonly PersonnePhysiqueVisitesLoadListPath = '/api/personnes-physiques/visites/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des visites d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueVisitesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueVisitesLoadList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueVisitesLoadListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des visites d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueVisitesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueVisitesLoadList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiqueVisitesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetVisite
   */
  static readonly PersonnePhysiqueGetVisitePath = '/api/personnes-physiques/visites/{personnePhysiqueId}/{visiteId}';

  /**
   * Renvoie la visite spécifiée pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetVisite()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetVisite$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<StrictHttpResponse<VisitePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetVisitePath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('visiteId', params.visiteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisitePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie la visite spécifiée pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetVisite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetVisite(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de la visite
     */
    visiteId: number;
  }): Observable<VisitePersonnePhysiqueDto> {

    return this.personnePhysiqueGetVisite$Response(params).pipe(
      map((r: StrictHttpResponse<VisitePersonnePhysiqueDto>) => r.body as VisitePersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueIncidentsLoadList
   */
  static readonly PersonnePhysiqueIncidentsLoadListPath = '/api/personnes-physiques/incidents/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des incidents d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueIncidentsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueIncidentsLoadList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueIncidentsLoadListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des incidents d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueIncidentsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueIncidentsLoadList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiqueIncidentsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetIncident
   */
  static readonly PersonnePhysiqueGetIncidentPath = '/api/personnes-physiques/incidents/{personnePhysiqueId}/{incidentId}';

  /**
   * Renvoie l'incident spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetIncident()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetIncident$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de l&#x27;incident
     */
    incidentId: number;
  }): Observable<StrictHttpResponse<IncidentsPersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetIncidentPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('incidentId', params.incidentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IncidentsPersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie l'incident spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetIncident$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetIncident(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant de l&#x27;incident
     */
    incidentId: number;
  }): Observable<IncidentsPersonnePhysiqueDto> {

    return this.personnePhysiqueGetIncident$Response(params).pipe(
      map((r: StrictHttpResponse<IncidentsPersonnePhysiqueDto>) => r.body as IncidentsPersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueQuotaLoadList
   */
  static readonly PersonnePhysiqueQuotaLoadListPath = '/api/personnes-physiques/quota/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des quotas d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueQuotaLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueQuotaLoadList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueQuotaLoadListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des quotas d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueQuotaLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueQuotaLoadList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiqueQuotaLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetQuotasList
   */
  static readonly PersonnePhysiqueGetQuotasListPath = '/api/personnes-physiques/quota/list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des quotas d'une personne physique.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetQuotasList()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetQuotasList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<Array<QuotaVisiteurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetQuotasListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<QuotaVisiteurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des quotas d'une personne physique.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetQuotasList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetQuotasList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<Array<QuotaVisiteurDto>> {

    return this.personnePhysiqueGetQuotasList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<QuotaVisiteurDto>>) => r.body as Array<QuotaVisiteurDto>)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetQuota
   */
  static readonly PersonnePhysiqueGetQuotaPath = '/api/personnes-physiques/quota/{personnePhysiqueId}/{typeDechetId}';

  /**
   * Renvoie le quota spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetQuota()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetQuota$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du type de déchets
     */
    typeDechetId: number;
  }): Observable<StrictHttpResponse<QuotaVisiteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetQuotaPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('typeDechetId', params.typeDechetId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuotaVisiteurDto>;
      })
    );
  }

  /**
   * Renvoie le quota spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetQuota$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetQuota(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du type de déchets
     */
    typeDechetId: number;
  }): Observable<QuotaVisiteurDto> {

    return this.personnePhysiqueGetQuota$Response(params).pipe(
      map((r: StrictHttpResponse<QuotaVisiteurDto>) => r.body as QuotaVisiteurDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetEmail
   */
  static readonly PersonnePhysiqueGetEmailPath = '/api/personnes-physiques/email/{personnePhysiqueId}';

  /**
   * Renvoie l'adresse email de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetEmail$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetEmailPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Renvoie l'adresse email de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetEmail(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<string> {

    return this.personnePhysiqueGetEmail$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation personnePhysiqueSetEmail
   */
  static readonly PersonnePhysiqueSetEmailPath = '/api/personnes-physiques/email/{personnePhysiqueId}';

  /**
   * Définit l'adresse email de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueSetEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueSetEmail$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Adresse email de la personne physique spécifiée
     */
    body: PersonnePhysiqueSetEmailRequestDto
  }): Observable<StrictHttpResponse<PersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueSetEmailPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Définit l'adresse email de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueSetEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueSetEmail(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Adresse email de la personne physique spécifiée
     */
    body: PersonnePhysiqueSetEmailRequestDto
  }): Observable<PersonnePhysiqueDto> {

    return this.personnePhysiqueSetEmail$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiqueDto>) => r.body as PersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetSoldeDonnerie
   */
  static readonly PersonnePhysiqueGetSoldeDonneriePath = '/api/personnes-physiques/solde-donnerie/{personnePhysiqueId}';

  /**
   * Renvoie le solde de donnerie de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetSoldeDonnerie()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetSoldeDonnerie$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetSoldeDonneriePath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Renvoie le solde de donnerie de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetSoldeDonnerie$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetSoldeDonnerie(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<number> {

    return this.personnePhysiqueGetSoldeDonnerie$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetListPlaques
   */
  static readonly PersonnePhysiqueGetListPlaquesPath = '/api/personnes-physiques/list-plaques';

  /**
   * Renvoie la liste des personnes physiques ayant un certain nombre de plaques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetListPlaques()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetListPlaques$Response(params?: {

    /**
     * Nombre minimum de plaques
     */
    minimum?: number;

    /**
     * true pour ne compter que les plaques actives, false pour toutes les compter
     */
    active?: boolean;

    /**
     * Elément de départ à renvoyer (pagination)
     */
    skip?: number;

    /**
     * Nombre d&#x27;éléments à renvoyer (pagination)
     */
    take?: number;
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetListPlaquesPath, 'get');
    if (params) {
      rb.query('minimum', params.minimum, {});
      rb.query('active', params.active, {});
      rb.query('skip', params.skip, {});
      rb.query('take', params.take, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes physiques ayant un certain nombre de plaques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetListPlaques$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetListPlaques(params?: {

    /**
     * Nombre minimum de plaques
     */
    minimum?: number;

    /**
     * true pour ne compter que les plaques actives, false pour toutes les compter
     */
    active?: boolean;

    /**
     * Elément de départ à renvoyer (pagination)
     */
    skip?: number;

    /**
     * Nombre d&#x27;éléments à renvoyer (pagination)
     */
    take?: number;
  }): Observable<LoadResult> {

    return this.personnePhysiqueGetListPlaques$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueRepresentantsLoadList
   */
  static readonly PersonnePhysiqueRepresentantsLoadListPath = '/api/personnes-physiques/representants/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des representants d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueRepresentantsLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueRepresentantsLoadList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueRepresentantsLoadListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des representants d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueRepresentantsLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueRepresentantsLoadList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiqueRepresentantsLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetRepresentant
   */
  static readonly PersonnePhysiqueGetRepresentantPath = '/api/personnes-physiques/representants/{personnePhysiqueId}/{representantId}';

  /**
   * Renvoie le representant spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetRepresentant()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetRepresentant$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du representant
     */
    representantId: number;
  }): Observable<StrictHttpResponse<PersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetRepresentantPath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('representantId', params.representantId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie le representant spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetRepresentant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetRepresentant(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du representant
     */
    representantId: number;
  }): Observable<PersonnePhysiqueDto> {

    return this.personnePhysiqueGetRepresentant$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiqueDto>) => r.body as PersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueRepresentesLoadList
   */
  static readonly PersonnePhysiqueRepresentesLoadListPath = '/api/personnes-physiques/representes/load-list/{personnePhysiqueId}';

  /**
   * Renvoie la liste des représentés d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueRepresentesLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueRepresentesLoadList$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueRepresentesLoadListPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des représentés d'une personne physique (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueRepresentesLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnePhysiqueRepresentesLoadList(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnePhysiqueRepresentesLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnePhysiqueGetRepresente
   */
  static readonly PersonnePhysiqueGetRepresentePath = '/api/personnes-physiques/representes/{personnePhysiqueId}/{representeId}';

  /**
   * Renvoie le représenté spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueGetRepresente()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetRepresente$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du représenté
     */
    representeId: number;
  }): Observable<StrictHttpResponse<PersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueGetRepresentePath, 'get');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('representeId', params.representeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Renvoie le représenté spécifié pour la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueGetRepresente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueGetRepresente(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du représenté
     */
    representeId: number;
  }): Observable<PersonnePhysiqueDto> {

    return this.personnePhysiqueGetRepresente$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiqueDto>) => r.body as PersonnePhysiqueDto)
    );
  }

  /**
   * Path part for operation personnePhysiqueAddRepresentant
   */
  static readonly PersonnePhysiqueAddRepresentantPath = '/api/personnes-physiques/representant/{personnePhysiqueId}/{representantId}';

  /**
   * Ajoute un représentant à une personne physique.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnePhysiqueAddRepresentant()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueAddRepresentant$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du représentant (PersonnePhysiqueId)
     */
    representantId: number;
  }): Observable<StrictHttpResponse<PersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesService.PersonnePhysiqueAddRepresentantPath, 'post');
    if (params) {
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.path('representantId', params.representantId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Ajoute un représentant à une personne physique.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnePhysiqueAddRepresentant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnePhysiqueAddRepresentant(params: {

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;

    /**
     * Identifiant du représentant (PersonnePhysiqueId)
     */
    representantId: number;
  }): Observable<PersonnePhysiqueDto> {

    return this.personnePhysiqueAddRepresentant$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnePhysiqueDto>) => r.body as PersonnePhysiqueDto)
    );
  }

}
